import { render, staticRenderFns } from "./Usermanagement.vue?vue&type=template&id=e52b94ca&scoped=true"
import script from "./Usermanagement.vue?vue&type=script&lang=js"
export * from "./Usermanagement.vue?vue&type=script&lang=js"
import style0 from "./Usermanagement.vue?vue&type=style&index=0&id=e52b94ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52b94ca",
  null
  
)

export default component.exports